import Cookies from 'js-cookie'
import { elementReady } from "../utils/ElementReady"

export default class CookiesConsent {
    constructor() {
        this.name = `cookie_consent`
        this.banner = document.querySelector(`.js-CookiesConsent`)

        if (this.banner) {
            this.addPadding()
            this.close = this.banner.querySelector(`.js-CookiesConsent__Close`)

            this.init()
        }

    }

    addPadding() {
        elementReady(`#main-block`).then((mainBlock) => {
            const paddingBottom = 100 + this.banner.offsetHeight
            mainBlock.style.paddingBottom = `${paddingBottom}px`
        })
    }

    consent() {
        Cookies.set(this.name, 1, {
            expires : 365 * 10,
            path : `/`,
        })
        this.banner.style.display = `none`
    }

    init() {
        this.close.addEventListener(`click`, e => {
            this.consent()
        })
    }
}
